/** @file Curve codes of every segment of a keyed channel; null when all segments are linear. */
import type { Curve } from '@pose2d/format/types';
import { compileCurve } from './compileCurve';
import type { CurveCode } from './compileCurve';

/**
 * Segment i (key i → i+1) uses key i's curve. `levels` holds the numeric key values (absolute cy); null means
 * progress form (v0 = 0, v1 = 1). Null result when every code is 0, so the timeline omits `c`.
 */
export function segmentCurves(keys: readonly { curve?: Curve | undefined }[], levels: readonly number[] | null): CurveCode[] | null {
  const out: CurveCode[] = [];
  for (let i = 0; i + 1 < keys.length; i++) {
    const v0 = levels === null ? 0 : (levels[i] ?? 0);
    const v1 = levels === null ? 1 : (levels[i + 1] ?? 0);
    out.push(compileCurve(keys[i]?.curve, v0, v1));
  }
  return out.every((c) => c === 0) ? null : out;
}
